export const BRAND_NAME = 'Brihha';
export const BRAND_SHORT_CODE = 'Brihha';
export const HELP_DESK = false;
export const TOPBAR_LOGO = false;
export const LOGIN_LOGO = false;
export const LOGIN_PAGEBEFORE = true;
export const LOGIN_PAGEAFTER = true;
